import { MenuCategoryProxy } from "@me-team/host/main/graphql/types";
import { SubcategoryInterface } from "../serviceCategory/ServicesCategoryNewInnit";
import { CategoryInterface } from "../../interfaces/meMenuInterfaces/interfaces";

export type MeMenuCategory = Pick<MenuCategoryProxy, "id" | "name" | "deleted"> & {
    childCategories?: MeMenuCategory[] | null;
};

class CategoryMeMenu {
    public static categoryModuleCreator = (
        meMenuCategories: MeMenuCategory[],
        categoryId: number | null,
        subcategoryId: number | null
    ): CategoryInterface[] => {
        const isActiveCategories = meMenuCategories?.filter((category) => !category?.deleted);

        return isActiveCategories.map((meMenuCategory) => {
            return {
                id: meMenuCategory.id,
                name: meMenuCategory.name,
                isOpen: !!(meMenuCategory.id === categoryId && subcategoryId),
                isPicked: !!(meMenuCategory.id === categoryId && !subcategoryId),
                isSubcategoryPiked: !!(meMenuCategory.id === categoryId && subcategoryId),
                subcategoryList: this.subcategoryModuleCreator(meMenuCategory.childCategories, subcategoryId),
            };
        });
    };

    public static subcategoryModuleCreator = (
        subcategories: MeMenuCategory[],
        currentSubcategoryId: number
    ): SubcategoryInterface[] => {
        const isActiveSubcategories = subcategories?.filter((subcategory) => !subcategory?.deleted);
        return isActiveSubcategories.map((subcategory) => {
            return {
                id: subcategory.id,
                name: subcategory.name,
                isPicked: subcategory.id === currentSubcategoryId,
            };
        });
    };
}

export default CategoryMeMenu;
